
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as contactQbkKFNMOH3tCZIH2wa32gXhUz2JB4YCNTagOdPoEoxoMeta } from "/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/case/[id]/contact.vue?macro=true";
import { default as summaryxglfrYzL9tuPT5TzP_45DQfPk_45kLE6p9UOjKIlHuUC1vgMeta } from "/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/case/[id]/summary.vue?macro=true";
import { default as prescreenUObViSVst6x8FYt4bddQZkdWl6KxvMQ7WxDkaCCbmp0Meta } from "/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/case/[id]/prescreen.vue?macro=true";
import { default as applicationr4GVfvq3fgqBbt2HWzooay0JjclgGtCHk1e7BOvCMKYMeta } from "/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/case/[id]/application.vue?macro=true";
import { default as attachmentspzROoKWUF9ADba_j_ZM9gWt0dq9_45vy39LjggLWWCfdAMeta } from "/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/case/[id]/attachments.vue?macro=true";
import { default as scholarshipWy4auoCya0Xf9aoDvDpjEldvsS15ygRhBMwb6v1JKB0Meta } from "/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/case/[id]/scholarship.vue?macro=true";
import { default as casejzXeS7u7ImkpOqESWv_451Wa9SVt_45mKaRvnl4ZqcsVecYMeta } from "/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/case.vue?macro=true";
import { default as indexcMZTFYZkffw4_sZgM8VrT95OvYMTc6QiktJru8WrgiYMeta } from "/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/index.vue?macro=true";
import { default as search_459utsAqytkABzkGe4qQePvDjDjCJM4q93_456LLB8ptW4Meta } from "/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/search.vue?macro=true";
import { default as new_45casecAUYtEUCt1Mbyki__45egkRcFw9CHSCAxzXDshwTcGTyEMeta } from "/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/new-case.vue?macro=true";
import { default as indexCjygi55pg61F9r4i3in2i4yAZ_2xBmouFrMdi9h1060Meta } from "/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/settings/index.vue?macro=true";
import { default as notifications70mK3_45YpI_mU3XwhWJOBe0HaTljXcHGoLC045JJRANYMeta } from "/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/settings/notifications.vue?macro=true";
import { default as settingsCCVO1fzhma1F7VWx5UZ1Fr_45u3GNZNOu5fDabAtNNgtwMeta } from "/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/settings.vue?macro=true";
import { default as users4lNm1X_Wy5bqeXGczEF_45kj_7WAoBMC09pmmYkhgv8JQMeta } from "/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/admin/users.vue?macro=true";
import { default as _91id_93Frerrf8jqls50P1He9BXprVDC0s1jUX1HpBjYy8uI58Meta } from "/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/report/[id].vue?macro=true";
import { default as providerlist9AkVhO6eAawEUIQtv9qH55X2c0CsBRrIxDauHGKjQLAMeta } from "/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/providerlist.vue?macro=true";
import { default as reports2hd8h7YC17FaYMIt1X_kndYoRaQ2ceIMoo6k0zy3LTkMeta } from "/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/csp-admin/reports.vue?macro=true";
import { default as manage_45flagsq__et_455qUjETK8mzQn4Yo7l7MFGkU1aPVStVtzGEYSEMeta } from "/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/admin/manage-flags.vue?macro=true";
import { default as thank_45youjh5lfdK2Yy5WksnervBtzSg7xcN08kH2fhotEaCWou0Meta } from "/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/eligible/thank-you.vue?macro=true";
import { default as thank_45youL1ITiHjIj9r4zITO_tOzR_459ZosZGD7lOEQt2QeXM444Meta } from "/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/ineligible/thank-you.vue?macro=true";
import { default as eligibilityU0AVtUUO9UGaDkrk_45fYEdZEnVLgHkx_Rs1ILFRmX9b0Meta } from "/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/public/csp/eligibility.vue?macro=true";
import { default as case_45assignmentsF7yz4uoMlXuGPzecQGHGezD3DxLSG2OciCAbCeXxoEgMeta } from "/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/csp-admin/case-assignments.vue?macro=true";
import { default as income_45eligibilityfMpzftyU5USLUGWW7JTzn_MZQbQ0umtpZg2ro5a0S6sMeta } from "/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/csp-admin/income-eligibility.vue?macro=true";
import { default as scholarship_45age_45dashboardwl_459pduUetYRhvlwjzu_OLCD0373jjLLVzgg6AaE0PQMeta } from "/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/csp-admin/scholarship-age-dashboard.vue?macro=true";
import { default as scholarship_45end_45date_45dashboardQwmVVha9DnSKic7ZWNlMkld51K3VRZeMEb_45ETenRW_8Meta } from "/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/csp-admin/scholarship-end-date-dashboard.vue?macro=true";
import { default as scholarship_45enrollment_45dashboard7ZAqSFB_454vTINuw7Tqrz0tOA53u3h3LtHakMPYChAkwMeta } from "/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/csp-admin/scholarship-enrollment-dashboard.vue?macro=true";
export default [
  {
    name: "case",
    path: "/case",
    component: () => import("/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/case.vue"),
    children: [
  {
    name: "case-id-contact",
    path: ":id()/contact",
    component: () => import("/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/case/[id]/contact.vue")
  },
  {
    name: "case-id-summary",
    path: ":id()/summary",
    component: () => import("/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/case/[id]/summary.vue")
  },
  {
    name: "case-id-prescreen",
    path: ":id()/prescreen",
    component: () => import("/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/case/[id]/prescreen.vue")
  },
  {
    name: "case-id-application",
    path: ":id()/application",
    component: () => import("/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/case/[id]/application.vue")
  },
  {
    name: "case-id-attachments",
    path: ":id()/attachments",
    component: () => import("/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/case/[id]/attachments.vue")
  },
  {
    name: "case-id-scholarship",
    path: ":id()/scholarship",
    component: () => import("/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/case/[id]/scholarship.vue")
  }
]
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/search.vue")
  },
  {
    name: "new-case",
    path: "/new-case",
    component: () => import("/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/new-case.vue")
  },
  {
    name: settingsCCVO1fzhma1F7VWx5UZ1Fr_45u3GNZNOu5fDabAtNNgtwMeta?.name,
    path: "/settings",
    component: () => import("/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/settings.vue"),
    children: [
  {
    name: "settings",
    path: "",
    component: () => import("/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/settings/index.vue")
  },
  {
    name: "settings-notifications",
    path: "notifications",
    component: () => import("/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/settings/notifications.vue")
  }
]
  },
  {
    name: "admin-users",
    path: "/admin/users",
    meta: { ...(users4lNm1X_Wy5bqeXGczEF_45kj_7WAoBMC09pmmYkhgv8JQMeta || {}), ...{"middleware":"admin-access"} },
    alias: ["/csp-admin/users"],
    component: () => import("/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/admin/users.vue")
  },
  {
    name: "report-id",
    path: "/report/:id()",
    component: () => import("/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/report/[id].vue")
  },
  {
    name: "providerlist",
    path: "/providerlist",
    component: () => import("/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/providerlist.vue")
  },
  {
    name: "csp-admin-reports",
    path: "/csp-admin/reports",
    component: () => import("/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/csp-admin/reports.vue")
  },
  {
    name: "admin-manage-flags",
    path: "/admin/manage-flags",
    meta: {"middleware":"admin-access"},
    component: () => import("/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/admin/manage-flags.vue")
  },
  {
    name: "eligible-thank-you",
    path: "/eligible/thank-you",
    meta: thank_45youjh5lfdK2Yy5WksnervBtzSg7xcN08kH2fhotEaCWou0Meta || {},
    component: () => import("/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/eligible/thank-you.vue")
  },
  {
    name: "ineligible-thank-you",
    path: "/ineligible/thank-you",
    meta: thank_45youL1ITiHjIj9r4zITO_tOzR_459ZosZGD7lOEQt2QeXM444Meta || {},
    component: () => import("/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/ineligible/thank-you.vue")
  },
  {
    name: "public-csp-eligibility",
    path: "/apply/childcare/eligibility",
    meta: eligibilityU0AVtUUO9UGaDkrk_45fYEdZEnVLgHkx_Rs1ILFRmX9b0Meta || {},
    component: () => import("/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/public/csp/eligibility.vue")
  },
  {
    name: "csp-admin-case-assignments",
    path: "/csp-admin/case-assignments",
    meta: {"middleware":"admin-access"},
    component: () => import("/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/csp-admin/case-assignments.vue")
  },
  {
    name: "csp-admin-income-eligibility",
    path: "/csp-admin/income-eligibility",
    component: () => import("/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/csp-admin/income-eligibility.vue")
  },
  {
    name: "csp-admin-scholarship-age-dashboard",
    path: "/csp-admin/scholarship-age-dashboard",
    component: () => import("/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/csp-admin/scholarship-age-dashboard.vue")
  },
  {
    name: "csp-admin-scholarship-end-date-dashboard",
    path: "/csp-admin/scholarship-end-date-dashboard",
    component: () => import("/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/csp-admin/scholarship-end-date-dashboard.vue")
  },
  {
    name: "csp-admin-scholarship-enrollment-dashboard",
    path: "/csp-admin/scholarship-enrollment-dashboard",
    component: () => import("/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/pages/csp-admin/scholarship-enrollment-dashboard.vue")
  }
]